export const AFTER_AUTH_REDIRECT_TO = "AFTER_AUTH_REDIRECT_TO";
